// import Vue from 'vue'
import store from '@/store'
import {setAuthInHeader} from "@/api/request";
import util from '@/mixins/util';
import VueJwtDecode from 'vue-jwt-decode'
import {localStorageKey,} from "@/api/config";
import Swal from "sweetalert2";
import {logout, markSessionInvalidated} from "@/utils/logout";

let JwtOption = {
    signKey: 'EGx2Avq6Bebs1URNLBqGEx9430NDcxbhK_ChozqduTg', // 변경완
    storage: 'localStorage',
    keyName: 'com.dgmonglab.rainbow-tv-webtoken',  //token 꼭 붙여주세요.
    ignoreExpiration: false,       // set true to ignore expiration date
    ignoreNotBefore: false,       // set true to ignore 'not before' date
}
let wcsTimer = [];
const VOLATILE_TOKEN_KEY = '__RAINBOW_VOLATILE_TOKEN__';

const getVolatileToken = () => {
    return window[VOLATILE_TOKEN_KEY] || null;
};

const setVolatileToken = (token) => {
    if (token) {
        window[VOLATILE_TOKEN_KEY] = token;
        return;
    }

    delete window[VOLATILE_TOKEN_KEY];
};

export const getStorageToken = () => { // 토큰 가져오기
    const volatileToken = getVolatileToken();
    if (volatileToken) {
        return volatileToken;
    }

    let token = window.localStorage.getItem(localStorageKey + 'token');
    let regex = /"/gi;
    if (!token) {
        return null;
    }
    let jwtToken = token.replace(regex, '');
    return jwtToken
}

export const getTokenObj = () => { // 토큰 가져오기
    let jwtToken = getStorageToken();
    if (jwtToken) {
        let token = jwtToken.replace(/-/g, "+").replace(/_/g, "/");
        let tokenObject = VueJwtDecode.decode(token);
        if (jwtToken && tokenObject) {
            return tokenObject;
        } else if (jwtToken) {
            return -1;
        } else {
            return null;
        }
    } else {
        return null;
    }

}


export const AuthCheck = () => { // 토큰이 로컬스토리지에 담겼을 시 사용
    let tokenObj = getTokenObj();
    if(tokenObj && tokenObj.hasOwnProperty('mb_end') && tokenObj.mb_end ===0){
        logout();
        return null;
    }
    if (tokenObj && tokenObj.hasOwnProperty('mb_no')) {
        return 1;
    } else if (tokenObj == -1) { //토큰값이 다를경우 토큰 지우고 null
        logout();
        return null;
    } else {
        return null;
    }
};

function getSuccess(storeSet, storeCount) {
    let finishCount = 0;
    let success = false;
    return function () {
        util.Array.each(storeSet, (item, index, storeSet) => {
            if (item.status == 'finish') {
                finishCount++
            }
        });
        success = (storeCount == finishCount) ? true : false
        return success;
    };
}

export const StoreProcess = (to, from, next) => { // 토큰이 로컬스토리지에 담겼을 시 사용
    //스토어가 필수 조건이 아니면 진행
    if (!to.meta.storeRequired) {
        next();
    }

    let params = to.params;
    let query = to.query;
    let configs = to.meta.storeConfig;

    let storeSet = [];
    let wcsTimerCnt = 0;
    util.Object.each(configs, (index, value, configs) => {
        if (value) {
            let obj = {
                'name': index,
                'required': value,
                'params': params,
                'query': query,
                'status': 'ready',
                'try': 0,
                'max': 8   //max는 5을 넘을 수 없습니다.
            }
            storeSet.push(obj)
        }
    });

    let storeCount = storeSet.length;
    let isSuccess = storeCheck(storeSet, next)
    if (isSuccess) {
        // clearInterval(wcsTimer);
        removeAllInterval();
        next();
        return false;
    }
    let wcsTimers = setInterval(function () {
        if (wcsTimerCnt <= 8) { // 0.5초 동안 리트라이 총 시도 횟수
            let isSuccess = storeCheck(storeSet, next)
            if (isSuccess) {
                // clearInterval(wcsTimer);
                removeAllInterval();
                next();
            }
            wcsTimerCnt++;
        } else {
            clearInterval(wcsTimer);
            next('/')
        }
    }.bind(this), 500);
    wcsTimer.push(wcsTimers);
};

function storeCheck(storeSet, next) {
    let storeCount = storeSet.length;
    util.Array.each(storeSet, (item, index, storeSet) => {
        if (item.status != 'finish') {
            item = storeRunning(item);
        }
        if (item.name == 'checkFinish' && item.status == 'fail') {
            removeAllInterval();
            next('/auth/register');
        } else if (item.status == 'fail') {  //하나라도 실패할 경우 인증으로
            removeAllInterval();
            next('/')
        }
    });

    let isSuccessFn = getSuccess(storeSet, storeCount);  //클로저 형태로 펑션을 리턴합니다. 펑션자체에 if 걸지마세요 항상 true입니다.
    let isSucess = isSuccessFn();
    return isSucess;
};

function removeAllInterval() {
    for (let i = 0; i < wcsTimer.length; i++) {
        clearInterval(wcsTimer[i]);
    }
    wcsTimer = [];
}

function storeRunning(storeItem) {
    if (storeItem.name == 'userInfo') {
        return AuthPayLoad(storeItem);
    } else if (storeItem.name === 'checkFinish') {
        return CheckFinishLogin(storeItem)
    } else if (storeItem.name === 'nftUser') {
        return CheckNftUser(storeItem)
    } else {
        return storeItem
    }


}


export const AuthPayLoad = (storeItem) => { // 토큰이 로컬스토리지에 담겼을 시 사용
    if (!storeItem.required) {
        storeItem.status = 'finish'
        return storeItem;
    }

    if (store.getters['userInfo/getUserInfo'] != undefined && store.getters['userInfo/getUserInfo'].mbNo) {
        //프로필 수정 페이지에서 프로필 값이 미입력일 경우 RouteLeave 를 못시키는 방향으로.
        storeItem.status = 'finish'
    } else {
        if (storeItem.try >= storeItem.max) {
            storeItem.status = 'fail'
        } else {
            storeItem.status = 'run'
            storeItem.try++;
        }
    }
    return storeItem;
};


export const CheckFinishLogin = (storeItem) => {
    if (store.getters['userInfo/getUserInfo'] != undefined && store.getters['userInfo/getUserInfo'].mb_is_verify === 1) {
        storeItem.status = 'finish';
    } else {
        if (storeItem.max <= storeItem.try) {
            storeItem.status = 'fail';
        } else {
            storeItem.status = 'run';
            storeItem.try++;
        }
    }
    return storeItem;
}

export const CheckNftUser = (storeItem) => {
    if (store.getters['userInfo/getUserInfo'] != undefined && store.getters['userInfo/getUserInfo'].mb_nft_token) {
        storeItem.status = 'finish';
    } else {
        let jwtToken = getStorageToken();
        if (storeItem.max <= storeItem.try) {
            storeItem.status = 'fail';
        } else {
            storeItem.status = 'run';
            storeItem.try++;
            if (storeItem.try == 1) {
                store.dispatch('userInfo/setNftUser', {token: jwtToken});
            }
        }
    }
    return storeItem;
}

export const storeSet = (to, from, next) => { // 토큰이 로컬스토리지에 담겼을 시 사용
    // to: 이동할 url에 해당하는 라우팅 객체

    if (to.matched.some(function (routeInfo) {
        return routeInfo.meta.storeRequired;
    })) {
        // 이동할 페이지에 인증 정보가 필요하면 경고 창을 띄우고 페이지 전환은 하지 않음
        let jwtToken = getStorageToken();
        let userInfoStatus = store.getters['userInfo/getUserInfo'].mbNo;
        if (!userInfoStatus) {
            let tokenObj = getTokenObj();
            if (tokenObj === -1) {
                logout();
            }
            if (tokenObj && tokenObj.hasOwnProperty('mb_no')) {
                store.dispatch('userInfo/setUserInfo', {token: jwtToken});
                StoreProcess(to, from, next);
            } else {
                StoreProcess(to, from, next);
            }
        } else {
            StoreProcess(to, from, next);
        }
    } else {
        next(); // 페이지 전환
    }
    ;
};


export const loginTokenSet = (token, options = {}) => {
    const {volatile = false} = options;

    if (!token) {
        setVolatileToken('');
        window.localStorage.removeItem(localStorageKey + 'token');
        setAuthInHeader('');
        return;
    }

    if (volatile) {
        setVolatileToken(String(token));
        window.localStorage.removeItem(localStorageKey + 'token');
    } else {
        setVolatileToken('');
        window.localStorage.setItem(localStorageKey + 'token', '"' + String(token) + '"');
    }

    markSessionInvalidated(false);
    setAuthInHeader(token);
}

export const markTempPasswordLoginFlow = () => {
    window.localStorage.setItem(localStorageKey + 'tempPasswordLoginFlow', 'true');
}

export const confirmLogout = () => {
    Swal.fire({
        title: '로그아웃 확인',
        html: '현재 계정이 로그인된 모든 기기에서 로그아웃됩니다.<br>로그아웃하시겠습니까?',
        confirmButtonText: '로그아웃',
        cancelButtonText: '닫기',
        showCancelButton: true,
        customClass: 'rainbow-default confirm',
    }).then((result) => {
        if (result.value) {
            logout();
        }
    });
}

export const returnRedirectPath = (to, from, next) => { // 리다이렉트 페이지 리턴
    let tokenObj = getTokenObj();
    if (tokenObj && tokenObj.hasOwnProperty('mb_no')) {
        if (tokenObj.g_type === 'creator') {
            return '/point';
        } else if (tokenObj.g_type === 'member') { // 슈퍼 관리자
            return '/point';
        } else {
            return '/onboard'
        }
    } else {
        return '/onboard'
    }
};
